export enum ServiceChargeModuleEnum {
  WITHDRAW = "WITHDRAW-CHARGE",
  CART_MINIMUM = "BARE-MIN-AMOUNT",
  SERVICES_CHARGE = "SERVICE-CHARGE",
}

export enum ServiceChargeTypeEnum {
  FIXED = "FIXED-TYPE",
  PERCENTAGE = "PERCENTAGE-TYPE",
}
